import { Modal as AntModal } from 'antd';
import Modal from './Modal';

export default Modal;
export const TaxarooModal = AntModal;
